import { render, staticRenderFns } from "./check_ads.vue?vue&type=template&id=edf6377e&scoped=true&"
import script from "./check_ads.vue?vue&type=script&lang=js&"
export * from "./check_ads.vue?vue&type=script&lang=js&"
import style0 from "./check_ads.vue?vue&type=style&index=0&id=edf6377e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf6377e",
  null
  
)

export default component.exports